module.exports = __webpack_public_path__ + "media/traditional serrated adenoma.bfa9f348.wav";